export default {
    OrderType: {
        Collection: 'Collection',
        Curbside: 'Curbside',
        Delivery: 'Delivery',
        Table: 'Table',
    }
}
